module.exports = __webpack_public_path__ + "static/media/SS.1734522d.svg";